export default __webpack_public_path__ + "static/media/Pharoh's Guard Cache.080864f5.jpg";